export const POWERSCHOOL_EXPORT_GETCONFIGURATION_LOADING =
  'POWERSCHOOL_EXPORT_GETCONFIGURATION_LOADING';
export const POWERSCHOOL_EXPORT_GETCONFIGURATION_SUCCESS =
  'POWERSCHOOL_EXPORT_GETCONFIGURATION_SUCCESS';
export const POWERSCHOOL_EXPORT_GETCONFIGURATION_ERROR =
  'POWERSCHOOL_EXPORT_GETCONFIGURATION_ERROR';

export const POWERSCHOOL_EXPORT_POSTSAVECONFIGURATION_LOADING =
  'POWERSCHOOL_EXPORT_POSTSAVECONFIGURATION_LOADING';
export const POWERSCHOOL_EXPORT_POSTSAVECONFIGURATION_SUCCESS =
  'POWERSCHOOL_EXPORT_POSTSAVECONFIGURATION_SUCCESS';
export const POWERSCHOOL_EXPORT_POSTSAVECONFIGURATION_ERROR =
  'POWERSCHOOL_EXPORT_POSTSAVECONFIGURATION_ERROR';

export const POWERSCHOOL_EXPORT_POSTTESTCONNECTION_LOADING =
  'POWERSCHOOL_EXPORT_POSTTESTCONNECTION_LOADING';
export const POWERSCHOOL_EXPORT_POSTTESTCONNECTION_SUCCESS =
  'POWERSCHOOL_EXPORT_POSTTESTCONNECTION_SUCCESS';
export const POWERSCHOOL_EXPORT_POSTTESTCONNECTION_ERROR =
  'POWERSCHOOL_EXPORT_POSTTESTCONNECTION_ERROR';

export const POWERSCHOOL_EXPORT_POSTEXPORT_LOADING =
  'POWERSCHOOL_EXPORT_POSTEXPORT_LOADING';
export const POWERSCHOOL_EXPORT_POSTEXPORT_SUCCESS =
  'POWERSCHOOL_EXPORT_POSTEXPORT_SUCCESS';
export const POWERSCHOOL_EXPORT_POSTEXPORT_ERROR =
  'POWERSCHOOL_EXPORT_POSTEXPORT_ERROR';



// WEBPACK FOOTER //
// ./src/pages/powerschoolintegration/powerschoolexport/state/types.js